<template>
    <div class="modal" :class="{mini: isMini}" v-show="isShow" :style="modalStyle" @click.stop="close">
        <div class="content" @click.stop>
            <div class="photo" :style="{ 'background-image': 'url(' + photoUrl + ')' }">
                <div class="btn" @click.stop="close">
                    <img src="@/assets/img/+.svg">
                </div>
            </div>
            <div class="info" :class="{hasOption: product.options.length}">
                <div class="title">
                    {{ product.name }}
                </div>
                <div class="description">{{ product.description }}</div>
            </div>
            <div class="options">
                <div class="option" v-for="option in product.options" :key="option.id">
                    <span>{{ option.name }}</span><span class="subtitle">{{ option | typeName }}</span>
                    <div class="item" v-for="item in option.items" :key="'item-' + item.id" @click="click(option, item)">
                        <div class="name" :class="{disable : option.disable && !item.selected}">
                            {{ item.name }}
                        </div>
                        <div class="left">
                            <div class="price" v-show="item.price">
                                + $ {{ item.price }}
                            </div>
                            <div v-show="option.type === 'multiple'" class="checkbox" :class="hasChecked(item)"></div>
                            <div v-show="option.type !== 'multiple'" class="radio" :class="hasChecked(item)"> </div>
                        </div>
                        <div v-if="!item.is_enable" class="shortage" @click.stop></div>
                    </div>
                </div>
            </div>
            <div class="note">
                <span>特殊備註</span>
                <a-textarea v-model="note" placeholder="寫下您的需求，我們會通知店家盡力為您處理，但不保證符合您的需求"></a-textarea>
            </div>
            <div class="empty"></div>
            <div class="buttons">
                <div class="count" v-if="isSetMode">
                    <div class="number">限購一份</div>
                </div>
                <div class="count" v-else>
                    <img src="@/assets/img/-.svg" @click="minus">
                    <div class="number">
                        {{ count }}
                    </div>
                    <img src="@/assets/img/+-gray.svg" @click="plus">
                </div>
                <div v-if="index < 0" class="button" :class="{active: isValid}" @click="addCart">
                    $ {{ product.is_elastic ? '依店內價格' : price * this.count }} 加入購物車
                </div>
                <div class="update" v-else>
                    <div class="button left" @click="deleteProduct">
                        <img src="@/assets/img/trash-white.svg">
                    </div>
                    <div class="button right" :class="{active: isValid}" @click="updateCart">
                        $ {{ product.is_elastic ? '依店內價格' : price * this.count }} 更新購物車
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import ATextare from '../components/AutoHeighTextarea';
    import * as R from 'ramda';
    import * as apis from '../../apis';
    import { mapActions, mapGetters } from 'vuex';
    import Swal from 'sweetalert2';
    import NoDrive from "../components/NoDrive";

    export default {
        name: 'ShopProduct',
        props: {
            isLiquor: {
                default: false,
            }
        },
        data() {
            return {
                isShow: false,
                index: -1,
                productIndex: -1,
                photoUrl: '',
                shop: null,
                product: {
                    name: '',
                    options: [],
                },
                checkOption: [],
                count: 1,
                note: '',
                isSetMode: false,
            }
        },
        components: {
            'a-textarea': ATextare,
            'no-drive': NoDrive,
        },
        computed: {
            isMini() {
                return !this.product.description && !this.product.options.length;
            },
            modalStyle() {
                return {
                    'top': this.isLiquor ? '10vh' : '0',
                    'height': this.isLiquor ? 'calc(100% - 10vh)' : '100%',
                }
            },
            isValid() {
                let checkItemIds = this.checkOption.map(option => option.id);
                return this.product.options.filter(options => options.min).reduce((valid, option) => {
                    let itemIds = option.items.filter(item => item.is_enable).map(item => item.id);
                    let count = R.intersection(checkItemIds, itemIds).length;
                    return valid && count >= option.min && count <= option.max;
                }, true);
            },
            price() {
                let price = this.product.price;

                price = this.checkOption.reduce((amount, option) => {
                    return amount + option.price;
                }, price);

                return price;
            },
            locationIndex() {
                if (!this.shop) {
                    return -1;
                }
                return this.findShopLocationIndex(this.shop.id);
            },
            ...mapGetters(['findShopLocationIndex', 'cartLocationById'])
        },
        methods: {
            show(shop, product, photoUrl, selected) {
                this.isShow = true;
                this.shop = shop;
                this.isSetMode = this.shop.set_mode;
                this.index = -1;
                this.productIndex = -1;
                this.product = R.clone(product);
                this.photoUrl = this.product.photo ? this.product.photo.url : photoUrl;
                this.checkOption = selected || [];
                this.count = 1;
                this.note = '';
            },
            update(index, product, productIndex, isSetModel = false) {
                apis.getShopProduct(product.id).then(res => {
                    this.isShow = true;
                    this.shop = null;
                    this.isSetMode = isSetModel;
                    this.index = index;
                    this.productIndex = productIndex;
                    this.checkOption = R.clone(product.options);
                    this.product = res.data;
                    this.photoUrl = product.url;
                    this.count = product.count;
                    this.note = product.note;
                });
            },
            close() {
                if (this.$route.hash) {
                    window.history.back();
                }

                this.isShow = false;
            },
            click(option, item) {
                let index = this.checkOption.findIndex(o => o.id === item.id);
                if (index >= 0) {
                    option.disable = false;
                    item.selected = false;
                    return this.checkOption.splice(index, 1);
                }

                if (option.type === 'multiple') {
                    return this.clickMultiple(option, item);
                }

                option.items.forEach(i => {
                    index = this.checkOption.findIndex(o => o.id === i.id);
                    if (index >= 0) {
                        i.selected = false;
                        return this.checkOption.splice(index, 1);
                    }
                });
                item.selected = true;
                return this.checkOption.push(item);
            },
            clickMultiple(option, item) {
                let itemIds = option.items.reduce((arr, item) => {
                    arr.push(item.id);
                    return arr;
                }, []);

                let count = this.checkOption.reduce((count, item) => {
                    return count + itemIds.includes(item.id);
                }, 0);

                if (count < option.max) {
                    item.selected = true;
                    this.checkOption.push(item);
                }

                if (count + 1 >= option.max) {
                    option.disable = true;
                }
            },
            minus() {
                this.count = (this.count - 1) || 1
            },
            plus() {
                this.count++;
            },
            hasChecked(item) {
                return {
                    checked: this.checkOption.findIndex(option => option.id === item.id) >= 0,
                }
            },
            deleteProduct() {
                this.deleteCartProduct({
                    index: this.index,
                    productIndex: this.productIndex,
                });

                this.close();
            },
            updateCart() {
                if (! this.isValid) {
                    return;
                }

                this.putCartProduct({
                    index: this.index,
                    productIndex: this.productIndex,
                    product: {
                        id: this.product.id,
                        name: this.product.name,
                        price: this.product.price,
                        sumPrice: this.price,
                        allOptions: this.product.options,
                        options: this.checkOption,
                        note: this.note,
                        count: this.count,
                        category_id: this.product.category_id,
                        url: this.photoUrl,
                    }
                });

                this.close();
            },
            addCart() {
                if (! this.isValid) {
                    return;
                }

                if (this.shop && this.isSetMode) {
                    let shopLocation = this.cartLocationById(this.locationIndex);
                    if (shopLocation && shopLocation.products && shopLocation.products.length) {
                        return Swal.fire({
                            type: 'error',
                            title: '每單只限量一件商品唷',
                            text: '如有需要，請移除其他商品在選購',
                        });
                    }
                }

                if (this.locationIndex >= 0) {
                    this.putLocation();
                }else {
                    this.addLocation();
                }

                let location = this.$route.params.location || null;
                if (location) {
                    this.putCartLastLocation(location);
                }

                this.close();
            },
            putLocation() {
                this.addProductToLocation({
                    key: this.locationIndex,
                    products: [
                        {
                            id: this.product.id,
                            name: this.product.name,
                            price: this.product.price,
                            sumPrice: this.price,
                            allOptions: this.product.options,
                            options: this.checkOption,
                            note: this.note,
                            count: this.count,
                            category_id: this.product.category_id,
                            url: this.photoUrl,
                            is_elastic: this.product.is_elastic,
                        }
                    ]
                });
            },
            addLocation() {
                this.addCartLocation({
                    shop_id: this.shop.id,
                    alias: this.shop.alias,
                    city: this.shop.city,
                    district: this.shop.district,
                    road: this.shop.road,
                    additional: this.shop.additional,
                    latitude: this.shop.latitude,
                    longitude: this.shop.longitude,
                    products: [
                        {
                            id: this.product.id,
                            name: this.product.name,
                            price: this.product.price,
                            sumPrice: this.price,
                            allOptions: this.product.options,
                            options: this.checkOption,
                            note: this.note,
                            count: this.count,
                            category_id: this.product.category_id,
                            url: this.photoUrl,
                            is_elastic: this.product.is_elastic,
                        }
                    ],
                });
            },
            ...mapActions(['initCart', 'addCartLocation', 'putCartLastLocation', 'addProductToLocation', 'putCartProduct', 'deleteCartProduct'])
        },
        filters: {
            typeName(option) {
                switch (option.type) {
                    case 'optional':
                        return '選填';
                    case 'radio':
                        return '必選';
                    case 'multiple':
                        return `最多可選 ${option.min} 到 ${option.max} 個項目`;
                    default:
                        return '未知狀態';
                }
            }
        }
    };
</script>

<style lang="scss" scoped>
    .modal {
        position: fixed;
        left: 0;
        border: 0;
        overflow-y: scroll;
        z-index: 99;
        background-color: rgba(0,0,0,0.4);
        width: inherit;

        &.mini {
            min-height: 50%;

            .content {
                border-radius: 10px 10px 0 0;
                height: auto !important;
            }

            .photo {
                border-radius: 10px 10px 0 0;
            }
        }

        &::-webkit-scrollbar {
            display: none;
        }

        .content {
            width: 100%;
            height: 100%;
            position: absolute;
            box-sizing: border-box;
            background-color: white;
            bottom: 0;
            display: flex;
            flex-direction: column;
            overflow-y: scroll;
        }

        .photo {
            background-position: 50% 50%;
            background-size: cover;
            background-repeat: no-repeat;
            min-height: 250px;
            width: 100%;
            display: flex;
            justify-content: flex-end;

            .btn {
                padding: 15px;
            }
        }

        .info {
            text-align: left;
            letter-spacing: 0;
            padding: 15px;

            &.hasOption {
                border-bottom: solid 5px #EEEEEE;
            }

            .title {
                color: #000000;
                font-size: 18px;
                font-weight: 500;
                line-height: 25px;
            }

            .description {
                color: #4A4A4A;
                font-size: 14px;
                line-height: 23.8px;
                margin-top: 15px;
                white-space: pre-line;
            }
        }

        .options {
            .option {
                text-align: left;
                padding: 10px 15px;

                &:not(:last-child) {
                    border-bottom: solid 5px #EEEEEE;
                }

                span {
                    color: #000000;
                    font-size: 18px;
                    font-weight: 500;
                    letter-spacing: 0;
                    line-height: 25px;
                }

                .subtitle {
                    color: #9B9B9B;
                    font-size: 14px;
                    letter-spacing: 0;
                    line-height: 20px;
                    margin-left: 5px;
                }

                .item {
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    padding: 10px;
                    cursor: pointer;
                    position: relative;

                    &:not(:last-child) {
                        border-bottom: solid 1px #DDDDDD;
                    }

                    .name {
                        color: #4A4A4A;
                        font-size: 16px;
                        letter-spacing: 0;
                        line-height: 22px;

                        &.disable {
                            color: #EEEEEE;
                        }
                    }

                    .price {
                        color: #9B9B9B;
                        font-size: 16px;
                        letter-spacing: 0;
                        line-height: 22px;
                        text-align: right;
                        margin-right: 15px;
                    }

                    .shortage {
                        background-color: rgba(255, 255, 255, .75);
                        position: absolute;
                        top: 0;
                        bottom: 0;
                        left: 0;
                        right: 0;
                    }
                }

                .left {
                    display: flex;
                    align-items: center;

                    .checkbox {
                        min-width: 18px;
                        min-height: 18px;
                        display: inline-block;
                        vertical-align: middle;
                        border: 1px solid rgba(221,221,221,1);
                        border-radius: 3px;
                        position: relative;
                        box-sizing: border-box;

                        &:after {
                            content: "";
                            position: absolute;
                            left: 5px;
                            top: 0;
                            bottom: 5px;
                            right: 4px;
                            transform: rotate(45deg);
                        }

                        &.checked {
                            background-color: #339933;

                            &:after {
                                border-bottom: 2px solid white;
                                border-right: 2px solid white;
                            }
                        }
                    }

                    .radio {
                        min-width: 18px;
                        min-height: 18px;
                        display: inline-block;
                        vertical-align: middle;
                        border: 1px solid rgba(221,221,221,1);
                        border-radius: 50%;
                        position: relative;
                        box-sizing: border-box;

                        &:after {
                            content: "";
                            position: absolute;
                            left: 2px;
                            top: 2px;
                            bottom: 2px;
                            right: 2px;
                            border: 1px solid transparent;
                            border-radius: 50%;
                        }

                        &.checked {
                            &:after {
                                border: 1px solid rgba(51,153,51,1);
                                background-color: rgba(51,153,51,1);
                            }
                        }
                    }
                }
            }
        }

        .note {
            border-radius: 5px;
            background-color: #FFFFFF;
            box-shadow: 0 0 3px 0 rgba(51,153,51,0.5);
            margin: 15px;
            padding: 10px;
            text-align: left;

            span {
                margin-bottom: 10px;
            }

            textarea {
                min-height: 3em !important;
            }
        }

        .empty {
            flex: 1;
        }

        .buttons {

            .count {
                display: flex;
                justify-content: center;
                align-items: center;
                padding: 25px 15px 15px 15px;

                img {
                    cursor: pointer;
                }

                .number {
                    width: 120px;
                    color: #000000;
                    font-size: 18px;
                    font-weight: 500;
                    letter-spacing: 0;
                    line-height: 25px;
                }
            }

            .button {
                cursor: pointer;
                border-radius: 35px;
                background-color: #9B9B9B;
                padding: 13px;
                margin: 10px 15px;
                color: #FFFFFF;
                font-size: 14px;
                letter-spacing: 0;
                line-height: 20px;
                text-align: center;

                &.active {
                    background-color: #339933;
                    color: #FFFFFF;
                }
            }

            .update {
                display: flex;

                .left {
                    flex: 0;
                    padding: 0 15px;
                    margin: 10px 0 10px 15px;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    background-color: #339933;
                    border-radius: 35px 0 0 35px;
                }

                .right {
                    flex: 1;
                    margin: 10px 15px 10px 5px;
                    border-radius: 0 35px 35px 0;
                }
            }
        }
    }
</style>
